import React, { useEffect } from "react";
import { CircularProgress, Container, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AdminsContext } from "../../contexts/AdminsContext";
import AddAdmin from "./components/AddAdmin";
import Page from "../../general_components/Page";
import StackCustom from "../../general_components/StackCustom";
import AdminCard from "./components/AdminCard";
import { PRIMARY_COLOR_DarkNavyBlue } from "../../constants/Colors";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import IconButton from "@mui/material/IconButton";
import IndexServices from "../../services/IndexServices";

const useStyles = makeStyles({
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "50vh", 
  },
});

export default function Admins() {
  const classes = useStyles();
  const adminsContext = React.useContext(AdminsContext);
  const { admins, handleDelete, setAdmins, openDel, setOpenDel, load,
          setClickedAdminId, handleEmpty, } = adminsContext;

  const [open, setOpen] = React.useState(false);
  useEffect(() => {
    const fetchAdmins = async () => {
      try {
        const response = await IndexServices.getAdmins();
        setAdmins(response?.data?.data);
      } catch (error) {
        console.error("Error in fetching admins:", error);
      }
    };
    fetchAdmins();
  }, [admins,setAdmins]);

  return (
    <Page title="ARCSMEN Design Lab | Admins">
      <Container sx={{ marginBottom: 5 }}>
        <StackCustom
          text="Admins"
          children={
            <IconButton
              style={{
                backgroundColor: PRIMARY_COLOR_DarkNavyBlue,
                color: "#fff",
                marginLeft: 6,
              }}
              variant={"contained"}
              onClick={() => setOpen(true)}
            >
              <AddRoundedIcon size={18} />
            </IconButton>
          }
        />
        <Grid container spacing={5} pt={4}>
          {Array.isArray(admins) && admins.length > 0 ? (
            admins.map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={`${index}Admins`}>
                <AdminCard
                  data={item}
                  index={index}
                  handleDelete={handleDelete}
                  openDel={openDel}
                  setOpenDel={setOpenDel}
                  load={load}
                  setClickedAdminId={setClickedAdminId}
                  handleEmpty={handleEmpty}
                />
              </Grid>
            ))
          ) : (
            <div>
              {admins && admins.length === 0 ? (
                <Typography sx={{ mt: "20px", ml: "40px" }} variant={"h6"}>
                  No Admin Found
                </Typography>
              ) : (
                <CircularProgress color="inherit" />
              )}
            </div>
          )}
        </Grid>
      </Container>
      <AddAdmin open={open} setOpen={setOpen} />
    </Page>
  );
}
